export const STORE_DETAILS_LABELS = 'StoreLocator.StoreDetail';
export const STORE_LANDING_LABELS = 'StoreLocator.StoreLanding';
export const STORE_LIST_LABELS = 'StoreLocator.StoreList';

export const lblStoredetailStoredetailTxt = 'lbl_storedetail_storedetailTxt';
export const lblStoredetailsCallstoreBtn = 'lbl_storedetails_callstore_btn';
export const lblStoredetailsChangestoreBtn = 'lbl_storedetails_changestore_btn';
export const lblStoredetailsEntranceType = 'lbl_storedetails_entranceType';
export const lblStoredetailsGetdirectionsBtn = 'lbl_storedetails_getdirections_btn';
export const lblStoredetailsLocationsDetailsBtn = 'lbl_storedetails_locations_details_btn';
export const lblStoredetailsLocationsMoreStore = 'lbl_storedetails_locations_more_store';
export const lblStoredetailsLocationsTitle = 'lbl_storedetails_locations_title';
export const lblStoredetailsMallType = 'lbl_storedetails_mallType';
export const lblStoredetailsOpenStoreMode = 'lbl_storedetails_open_store_mode';
export const lblStoredetailsSeemorestoresBtn = 'lbl_storedetails_seemorestores_btn';
export const lblStoredetailsSelectDifferentStore = 'lbl_storedetails_selectDifferentStore';
export const lblStoredetailsSelectedStore = 'lbl_storedetails_selectedStore';
export const lblStoredetailsSetfavBtn = 'lbl_storedetails_setfav_btn';
export const lblStoredetailsShopThisStore = 'lbl_storedetails_shopThisStore';
export const lblStoredetailsSpecialHoursText = 'lbl_storedetails_specialHoursText';
export const lblStoredetailsSpecialHoursTextClosed = 'lbl_storedetails_specialHoursText_closed';
export const lblStoredetailsSpecialHoursTextCloses = 'lbl_storedetails_specialHoursText_closes';
export const lblStoredetailsSpecialHoursTextHolidayHours =
  'lbl_storedetails_specialHoursText_holiday_hours';
export const lblStoredetailsSpecialHoursTextOpen = 'lbl_storedetails_specialHoursText_open';
export const lblStoredetailsSpecialHoursTextOpens = 'lbl_storedetails_specialHoursText_opens';
export const lblStoredetailsWelcomeTo = 'lbl_storedetails_welcome_to';
export const lblStoreldetailsClosed = 'lbl_storeldetails_closed';

// store landing labels
export const lblLocationAccessCoolRight = 'lbl_locationAccess_coolRight';
export const lblLocationAccessDesc = 'lbl_locationAccess_desc';
export const lblLocationAccessFindItInStoreToday = 'lbl_locationAccess_findItInStoreToday';
export const lblLocationAccessMaybelater = 'lbl_locationAccess_maybelater';
export const lblLocationAccessTurnOnLocation = 'lbl_locationAccess_turnOnLocation';
export const lblStoredetailSelectstoreBtn = 'lbl_storedetail_selectstore_btn';
export const lblStorelandingAllUSCAStores = 'lbl_storelanding_allUSCAStores';
export const lblStorelandingAtThisPlace = 'lbl_storelanding_atThisPlace';
export const lblStorelandingCurrentLocation = 'lbl_storelanding_currentLocation';
export const lblStorelandingDistancePlaceholder = 'lbl_storelanding_distancePlaceholder';
export const lblStorelandingErrorLabel = 'lbl_storelanding_errorLabel';
export const lblStorelandingFavStore = 'lbl_storelanding_favStore';
export const lblStorelandingFavStoreHeading = 'lbl_storelanding_favStoreHeading';
export const lblStorelandingFavoriteStore = 'lbl_storelanding_favorite_store';
export const lblStorelandingFindStoreHeading = 'lbl_storelanding_findStoreHeading';
export const lblStorelandingFindAStoreNearYou = 'lbl_storelanding_find_a_store_near_you';
export const lblStorelandingGetdirectionsLink = 'lbl_storelanding_getdirections_link';
export const lblStorelandingInternationalStores = 'lbl_storelanding_internationalStores';
export const lblStorelandingInvalidAddressError = 'lbl_storelanding_invalidAddressError';
export const lblStorelandingMiles = 'lbl_storelanding_miles';
export const lblStorelandingMilesAway = 'lbl_storelanding_milesAway';
export const lblStorelandingNoStoresFound = 'lbl_storelanding_noStoresFound';
export const lblStorelandingOpenInterval = 'lbl_storelanding_openInterval';
export const lblStorelandingOpensAt = 'lbl_storelanding_opensAt';
export const lblStorelandingOutletStores = 'lbl_storelanding_outletStores';
export const lblStorelandingSearch = 'lbl_storelanding_search';
export const lblStorelandingSelectAStore = 'lbl_storelanding_select_a_store';
export const lblStorelandingSetfavStore = 'lbl_storelanding_setfavStore';
export const lblStorelandingStoreNearYou = 'lbl_storelanding_storeNearYou';
export const lblStorelandingStoreSearchPlaceholder = 'lbl_storelanding_storeSearchPlaceholder';
export const lblStorelandingStoredetailsLink = 'lbl_storelanding_storedetails_link';
export const lblStorelandingValidErrorLabel = 'lbl_storelanding_validErrorLabel';
export const lblStorelandingViewList = 'lbl_storelanding_viewList';
export const lblStorelandingViewMap = 'lbl_storelanding_viewMap';
export const lblStorelandingWithin = 'lbl_storelanding_within';
// export const lblStoreldetailsClosed = 'lbl_storeldetails_closed';

// Store list labels
// export const lblStorelandingAtThisPlace = 'lbl_storelanding_atThisPlace';
export const lblStorelistSearchByStates = 'lbl_storelist_searchByStates';
export const lblStorelistSearchByStatesDropdown = 'lbl_storelist_searchByStates_dropdown';
export const lblStorelistShopInShop = 'lbl_storelist_shop_in_shop';
export const lblStoreSpecials = 'lbl_Store_Specials';
export const lblLimitedEditions = 'lbl_Limited_Editions';

export const StoreLocatorLabels = {
  StoreLocator: {
    StoreDetail: {
      [lblStoredetailStoredetailTxt]: 'STORE DETAILS',
      [lblStoredetailsCallstoreBtn]: 'Call Store',
      [lblStoredetailsChangestoreBtn]: 'Change Favorite Store',
      [lblStoredetailsEntranceType]: 'Type of Entrance:',
      [lblStoredetailsGetdirectionsBtn]: 'Directions',
      [lblStoredetailsLocationsDetailsBtn]: 'SEE STORE DETAILS',
      [lblStoredetailsLocationsMoreStore]: 'See more stores',
      [lblStoredetailsLocationsTitle]: 'OTHER LOCATIONS NEAR YOU',
      [lblStoredetailsMallType]: 'Mall Type:',
      [lblStoredetailsOpenStoreMode]: 'OPEN IN-STORE MODE',
      [lblStoredetailsSeemorestoresBtn]: 'SEE MORE STORES',
      [lblStoredetailsSelectDifferentStore]: 'Select a Different Store',
      [lblStoredetailsSelectedStore]: 'Selected Store',
      [lblStoredetailsSetfavBtn]: 'Set as favorite',
      [lblStoredetailsShopThisStore]: 'Shop This Store',
      [lblStoredetailsSpecialHoursText]: 'This store will remain open from-on',
      [lblStoredetailsSpecialHoursTextClosed]: 'This store will remain closed on',
      [lblStoredetailsSpecialHoursTextCloses]: 'Closes',
      [lblStoredetailsSpecialHoursTextHolidayHours]: 'Holiday Hours',
      [lblStoredetailsSpecialHoursTextOpen]: 'Open',
      [lblStoredetailsSpecialHoursTextOpens]: 'Opens',
      [lblStoredetailsWelcomeTo]: 'Welcome To',
      [lblStoreldetailsClosed]: 'Closed',
      [lblStoreSpecials]: 'Store Specials',
      [lblLimitedEditions]: 'Limited edition selections at special prices.',
    },
    StoreLanding: {
      [lblLocationAccessCoolRight]: 'Cool. right?!',
      [lblLocationAccessDesc]:
        'Turn on your location so we can show you every style, color and size available in your nearest store .',
      [lblLocationAccessFindItInStoreToday]: 'Find It In Store Today',
      [lblLocationAccessMaybelater]: 'Maybe later',
      [lblLocationAccessTurnOnLocation]: 'TURN ON LOCATION',
      [lblStoredetailSelectstoreBtn]: 'Select Store',
      [lblStorelandingAllUSCAStores]: 'All US & Canada Stores',
      [lblStorelandingAtThisPlace]: 'at this PLACE!',
      [lblStorelandingCurrentLocation]: 'Use my current location',
      [lblStorelandingDistancePlaceholder]: 'Distance',
      [lblStorelandingErrorLabel]:
        'Please re-type address & select location from dropdown suggestions.',
      [lblStorelandingFavStore]: 'Your Store',
      [lblStorelandingFavStoreHeading]: 'Your Favorite Store',
      [lblStorelandingFavoriteStore]: 'FAVORITE STORE',
      [lblStorelandingFindStoreHeading]: 'Find a Store',
      [lblStorelandingFindAStoreNearYou]: 'FIND A STORE NEAR YOU',
      [lblStorelandingGetdirectionsLink]: 'Get Directions',
      [lblStorelandingInternationalStores]: 'International Stores',
      [lblStorelandingInvalidAddressError]:
        'The value entered in the street address has special character.',
      [lblStorelandingMiles]: 'MILES',
      [lblStorelandingMilesAway]: 'miles away',
      [lblStorelandingNoStoresFound]:
        'Sorry, we couldn’t find any stores for your search. Please try again.',
      [lblStorelandingOpenInterval]: 'Open until',
      [lblStorelandingOpensAt]: 'opens at',
      [lblStorelandingOutletStores]: 'Only Outlet Stores',
      [lblStorelandingSearch]: 'SEARCH',
      [lblStorelandingSelectAStore]: 'SELECT A STORE',
      [lblStorelandingSetfavStore]: 'SET AS FAVORITE',
      [lblStorelandingStoreNearYou]: 'STORES NEAR YOU',
      [lblStorelandingStoreSearchPlaceholder]: 'Zip Code or City, State',
      [lblStorelandingStoredetailsLink]: 'Store Details',
      [lblStorelandingValidErrorLabel]: 'Please enter a valid street address',
      [lblStorelandingViewList]: 'View List',
      [lblStorelandingViewMap]: 'View Map',
      [lblStorelandingWithin]: 'WITHIN',
      [lblStoreldetailsClosed]: 'Closed',
    },
    StoreList: {
      [lblStorelandingAtThisPlace]: 'at this PLACE!',
      [lblStorelistSearchByStates]: 'SEARCH FOR STORES BY STATE',
      [lblStorelistSearchByStatesDropdown]: 'Select a State',
      [lblStorelistShopInShop]: 'shop-in-shop',
    },
  },
};
